import { stripeAccountNameSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../contract';

export const subscriptionRouter = c.router(
  {
    stripeUnsubscribe: {
      summary: 'Turns auto renew off',
      method: 'POST',
      path: '/stripe-unsubscribe',
      body: z.object({
        subscriptionId: z.string(),
        stripeAccountName: stripeAccountNameSchema,
      }),
      responses: {
        200: z.literal('ok'),
        422: z.literal('unprocessable'),
      },
    },
    stripeRenew: {
      summary: 'Renew stripe subscription',
      method: 'POST',
      path: '/stripe-renew',
      body: z.object({
        subscriptionId: z.string(),
        stripeAccountName: stripeAccountNameSchema,
      }),
      responses: {
        200: z.literal('ok'),
        422: z.literal('unprocessable'),
      },
    },
    applyRenewalOffer: {
      summary: 'Apply renewal offer',
      method: 'POST',
      path: '/apply-renewal-offer',
      body: z.object({
        subscriptionId: z.string(),
        couponId: z.string(),
      }),
      responses: {
        200: z.literal('ok'),
        422: z.literal('unprocessable'),
      },
    },
    cancelSubscriptionSchedule: {
      summary: 'Cancel subscription schedule',
      method: 'POST',
      path: '/cancel-subscription-schedule',
      body: z.object({
        subscriptionScheduleId: z.string(),
        stripeAccountName: stripeAccountNameSchema,
      }),
      responses: {
        200: z.literal('ok'),
      },
    },
  },
  { pathPrefix: '/subscription' },
);
